module.exports = __webpack_public_path__ + "static/on-premises-9b75c9e4c92793fec3f628adceff37cd.png";